<template>
    <div class="mt-4 sm:mt-0">
        <ul id="tabs" class="hidden sm:inline-flex bg-muted rounded-lg sm:rounded-full">
            <li v-for="item in items"
                class="px-4 py-2 rounded-full ml-1 mt-1 mb-1 mr-0 sm:mr-2 transition ease-in-out hover:bg-grey-100"
                :class="{'bg-gradient-to-tr from-green-100 to-green-200 text-white': activeItem === item.value }">
                <a @click="clickedTab(item.value, $event)"
                   class="font-light"
                   href="#"
                   :class="{'!font-bold': activeItem === item.value }"
                   :id="item.value">{{ item.text }}</a>
            </li>
        </ul>

        <!-- v-select on mobile -->
        <InputSelect class="block sm:hidden"
                     :modelValue="activeItem"
                     :options="items"
                     labelKey="text"
                     :reduce="item => item.value"
                     @update:modelValue="clickedTab($event)"
        ></InputSelect>
    </div>
</template>

<script>
import InputSelect from "@/Components/Forms/Inputs/InputSelect";

export default {
    name: "Tabs",
    components: {InputSelect},
    props:
        {
            items: Array,
            activeItem: {
                type: String,
                default: null
            },
        },
    methods:
        {
            clickedTab: function (value, event) {
                this.$emit("tabChange", value);

                if (event) {
                    event.preventDefault();
                }
            }
        }
};
</script>

<style scoped>

</style>
